module.exports = __webpack_public_path__ + "23759f4c65f33c096dc2d56b8fe2984e.svg";